/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamDisciplineSingle200,
  GetApiV1ExamDisciplineSingle400,
  GetApiV1ExamDisciplineSingle401,
  GetApiV1ExamDisciplineSingle500,
  GetApiV1ExamDisciplineSingleQueryParams,
  GetApiV1ExamDisciplineSingleQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamDisciplineSingle.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamDisciplineSingleQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    id: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamDisciplineSingleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamDisciplineSingle200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamDisciplineSingle200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamDisciplineSingle400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineSingle400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamDisciplineSingle401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineSingle401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamDisciplineSingle500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineSingle500>;

export const getApiV1ExamDisciplineSingleQueryResponseSchema = z.lazy(
  () => getApiV1ExamDisciplineSingle200Schema,
) as unknown as ToZod<GetApiV1ExamDisciplineSingleQueryResponse>;
